document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fbt-section]').forEach(initFrequentlyBoughtTogether);
});

function initFrequentlyBoughtTogether(section) {
  var items = section.querySelectorAll('[data-fbt-item]');
  var addBtn = section.querySelector('[data-fbt-add-btn]');
  var btnText = section.querySelector('[data-fbt-btn-text]');
  var totalEl = section.querySelector('[data-fbt-total]');
  var countEl = section.querySelector('[data-fbt-count]');
  var messageEl = section.querySelector('[data-fbt-message]');

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function syncCheckboxVisual(item) {
    var bead = item.querySelector('.fbt__bead');
    var checkbox = item.querySelector('input[type="checkbox"]');
    if (!bead || !checkbox) return;
    bead.classList.toggle('is-checked', checkbox.checked);
  }

  function syncAllCheckboxVisuals() {
    items.forEach(syncCheckboxVisual);
  }

  function getSelectedItems() {
    var selected = [];

    items.forEach(function (item) {
      var checkbox = item.querySelector('input[type="checkbox"]');
      // Main item has no checkbox input (it's locked/always included)
      if (checkbox && !checkbox.checked) return;

      var variantSelect = item.querySelector('[data-fbt-variant-select]');
      var variantId = variantSelect ? variantSelect.value : item.getAttribute('data-fbt-variant-id');
      var price = variantSelect
        ? parseInt(variantSelect.options[variantSelect.selectedIndex].getAttribute('data-price'), 10)
        : parseInt(item.getAttribute('data-fbt-price'), 10);

      selected.push({ id: variantId, price: price });
    });

    return selected;
  }

  function updateTotal() {
    var selected = getSelectedItems();
    var total = selected.reduce(function (sum, item) { return sum + item.price; }, 0);

    if (totalEl) totalEl.textContent = formatMoney(total);
    if (countEl) countEl.textContent = selected.length;
    if (addBtn) addBtn.disabled = selected.length === 0;
  }

  function showMessage(text, isError) {
    if (!messageEl) return;
    messageEl.hidden = false;
    messageEl.textContent = text;
    messageEl.classList.toggle('fbt__message--error', !!isError);
    window.clearTimeout(messageEl._fbtTimeout);
    messageEl._fbtTimeout = window.setTimeout(function () {
      messageEl.hidden = true;
      messageEl.classList.remove('fbt__message--error');
    }, 4000);
  }

  function refreshCartUI() {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(cart);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(cart);
        }
      })
      .catch(function () {});

    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      fetch('/?sections=cart-icon-bubble')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          if (sections && sections['cart-icon-bubble']) {
            var temp = document.createElement('div');
            temp.innerHTML = sections['cart-icon-bubble'];
            var fresh = temp.querySelector('.shopify-section') || temp.firstElementChild;
            if (fresh) cartIconBubble.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  section.addEventListener('change', function (event) {
    if (event.target.matches('input[type="checkbox"], [data-fbt-variant-select]')) {
      updateTotal();
      syncAllCheckboxVisuals();
    }
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var selected = getSelectedItems();
      if (selected.length === 0) return;

      addBtn.disabled = true;
      var originalText = btnText.textContent;
      btnText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: selected.map(function (item) {
            return { id: parseInt(item.id, 10), quantity: 1 };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) { throw err; });
          }
          return response.json();
        })
        .then(function () {
          btnText.textContent = originalText;
          addBtn.disabled = false;
          showMessage('Added to cart!', false);
          refreshCartUI();
        })
        .catch(function (err) {
          btnText.textContent = originalText;
          addBtn.disabled = false;
          showMessage((err && err.description) || 'Something went wrong, please try again.', true);
        });
    });
  }

  syncAllCheckboxVisuals();
  updateTotal();
}